import { Cell } from './cell';
import { Column } from './column';
import { DataSet } from './data-set';

export class Row {
  public isSelected: boolean = false;
  public isDeleted: boolean = false;
  public isInEditing: boolean = false;
  public isUndo: boolean = false;
  public isReissued: boolean = false;
  public isRevoked: boolean = false;
  public action: string = '';
  public isNewRow: boolean = false;
  public disableCheckBox: boolean = false;
  public checked: boolean = false;
  public cells: Cell[] = [];
  public highlighted: boolean = false;
  public isEditable: boolean = true;
  public isHyperLink: boolean = false;
  public success: boolean = false;

  constructor(
    public index: number,
    public data: any,
    protected _dataSet: DataSet,
    public editable: string
  ) {
    this.isEditable = editable.toLowerCase() === 'y' ? true : false;
    this.process();
  }

  public getCell(column: Column): Cell {
    return this.cells.find((el) => el.getColumn() === column);
  }

  public getCellByColumnTitle(title: string): Cell {
    return this.cells.find(
      (el) => el.getColumn().title.toLowerCase() === title
    );
  }

  public getCellByColumnId(id: string): Cell {
    return this.cells.find((el) => el.getColumn().id === id);
  }

  public getCells() {
    return this.cells;
  }

  public getData(): any {
    return this.data;
  }

  public getIsSelected(): boolean {
    return this.isSelected;
  }

  public getNewData(): any {
    const values = Object.assign({}, this.data);
    this.getCells().forEach(
      (cell) => (values[cell.getColumn().id] = cell.getValidator().value)
    );
    return values;
  }

  public setData(data: any): any {
    this.data = data;

    this.process();
  }

  public getValidator(): any {
    return this._dataSet.getRowValidator(this.index, this.data.uid);
  }

  public process() {
    this.cells = [];
    this._dataSet.getColumns().forEach((column: Column) => {
      const cell = this.createCell(column);
      this.cells.push(cell);
    });
  }

  public createCell(column: Column): Cell {
    const defValue = (column as any).settings.defaultValue
      ? (column as any).settings.defaultValue
      : '';
    const value =
      typeof this.data[column.id] === 'undefined'
        ? defValue
        : this.data[column.id];
    return new Cell(value, this, column, this._dataSet);
  }
}
